"use client";

import { colors } from "@/styles/design-tokens";

export interface BrandCardProps {
  brand: { brand_name: string; brand_description?: string | null; justification?: string };
  onClick: () => void;
}

export function BrandCard({ brand, onClick }: BrandCardProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={`View ${brand.brand_name} brand page`}
      className="group w-full cursor-pointer bg-white text-left transition-all duration-200 hover:shadow-md"
      style={{ border: `1px solid ${colors.divider.default}`, borderRadius: "8px" }}
    >
      <div className="p-2.5">
        <h4
          className="mb-1 text-xs font-medium group-hover:underline"
          style={{ color: colors.text.softestBlack }}
        >
          {brand.brand_name}
        </h4>
        {brand.brand_description && (
          <p
            className="mb-1.5 line-clamp-2 text-xs leading-relaxed"
            style={{ color: colors.text.accentMdGray }}
          >
            {brand.brand_description}
          </p>
        )}
        <p className="text-xs italic leading-relaxed" style={{ color: colors.text.grayLightest }}>
          {brand.justification}
        </p>
      </div>
    </button>
  );
}
